<div class="efv2-container">
  <div class="efv2-header-box">
    <div class="efv2-header-title" *ngIf="title" [innerHTML]="title"></div>
    <div class="efv2-header-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
  </div>
  <div class="efv2-main-row">
    <div class="efv2-main-left">
      <div class="efv2-main-card-wrapper">
        <div class="efv2-corner-button" (click)="goToFundraiser()">
          <mat-icon class="efv2-mat-icon">arrow_forward</mat-icon>
        </div>
        <div class="efv2-image-box">
          <img loading="lazy" [attr.data-src]="fundraiser?.gallery[0]?.cdn_path" [default]="utils.defaultImg"
            alt="supporter" />
          <div class="efv2-img-overlay"></div>
          <div class="efv2-image-content">
            <div class="efv2-image-title">Thank you for supporting {{ beneficiaryName }}. </div>
            <div class="efv2-image-update-ctn" (click)="goToFundraiserUpdates()">
              VIEW fundraiser UPDATES
              <div class="icon-wrap">
                <mat-icon>arrow_forward</mat-icon>
              </div>
            </div>
          </div>
        </div>
        <div class="efv2-stats">
          <div class="efv2-stats-col" *ngIf="fundraiser?.raised?.raised && pageType =='FUNDRAISER'">
            <div class="efv2-stats-value">
              <app-currency-icon [currency]="currency"></app-currency-icon>{{ fundraiser?.raised?.raised | inrFormat }}
            </div>
            <div class="efv2-stats-label">FUNDS RAISED</div>
          </div>
          <div class="efv2-stats-col" *ngIf="fundraiser?.raised?.backers">
            <div class="efv2-stats-value">
              <span class="efv2-supporters-avatars">
                <img *ngFor="let supporter of supporterImages" [src]="supporter" class="efv2-supporter-avatar"
                  alt="supporter" />
              </span>
              {{ fundraiser?.raised?.backers || 0 }}
            </div>
            <div class="efv2-stats-label">SUPPORTERS</div>
          </div>
          <div class="efv2-stats-col" *ngIf="fundraiser?.end_date">
            <div class="efv2-stats-value">
              {{ fundraiser?.end_date | date:'dd/MM/yy' }}
            </div>
            <div class="efv2-stats-label">END DATE</div>
          </div>
        </div>
      </div>
    </div>
    <div class="download-app-wrapper" *ngIf="isMobile" (click)="onDownloadKettoApp()">
      <div class="content">
        <div class="logo"><img loading="lazy" [attr.data-src]="'/assets/images/download_app.png'" alt=""></div>
        <div class="right-section">
          <div class="text">
            <div class="title">Download the Ketto app!</div>
            <div class="sub-title">Make good things happen & get rewarded</div>
          </div>
          <div class="icon-wrap">
            <mat-icon>arrow_forward</mat-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="efv2-main-right" [ngClass]="{'update-padding': endedCampaignPageData.length < 2}"
      *ngIf="endedCampaignPageData.length > 0">
      <div class="efv2-help-header-row">
        <div class="efv2-help-title">
          {{'Help someone else today'}}
        </div>
        <div class="efv2-help-viewmore" (click)="goToBrowseFundraiser()">VIEW MORE
          <mat-icon>arrow_forward_ios</mat-icon>
        </div>
      </div>
      <div *ngIf="!isMobile" class="glideContainer" [ngClass]="{'remove_arrow':endedCampaignPageData.length <= 2}">
        <ngx-glide arrowLeftLabel="" arrowRightLabel="" perView="2" gap="0" [breakpoints]="breakpoints">
          <ng-container *ngFor="let item of endedCampaignPageData;let i = index">
            <div class="cardContainer">
              <app-fundraiser-card [fundraiser]="item" [eventInfo]="eventInfo"></app-fundraiser-card>
            </div>
          </ng-container>
        </ngx-glide>
      </div>
      <div class="glide-container" *ngIf="isMobile && endedCampaignPageData?.length">
        <ngx-glide [showArrows]="endedCampaignPageData.length > 1" [showBullets]="endedCampaignPageData.length > 1"
          [autoplay]="0" [hoverpause]="true" [perView]="isMobile ? 1.6 : 2" arrowLeftLabel=""
          arrowRightLabel="">
          <ng-container *ngIf="endedCampaignPageDataType === 'SIMILAR_FUNDRAISER'">
            <div class="card-container" *ngFor="let item of endedCampaignPageData">
              <app-fundraiser-card [fundraiser]="item" [eventInfo]="eventInfo"></app-fundraiser-card>
            </div>
          </ng-container>
          <ng-container *ngIf="endedCampaignPageDataType === 'TRENDING_FUNDRAISER'">
            <div class="card-container" *ngFor="let item of endedCampaignPageData">
              <app-fundraiser-card [fundraiser]="item" [eventInfo]="eventInfo"></app-fundraiser-card>
            </div>
          </ng-container>
        </ngx-glide>
      </div>
    </div>
  </div>
</div>

<div class="docked-btn-wrapper" *ngIf="isMobile">
  <button (click)="goToBrowseFundraiser()" mat-button>
    Find similar fundraisers
    <span><mat-icon>arrow_forward_ios</mat-icon></span>
  </button>
</div>